import React from "react";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { WhatsappCompletionMessages } from "@/messages/platforms/whatsappConnection/whatsappCompletionMessages";

interface Props {
  messages: WhatsappCompletionMessages;
}

export function Completion({ messages }: Props) {
  return (
    <MDBox>
      <MDBox width="82%" textAlign="left" mx="auto" my={4}>
        <MDBox mb={1}>
          <MDTypography variant="body2" color="text">
            {messages.whatsappCompletionMessagesText1Part1}
          </MDTypography>
        </MDBox>
        <MDTypography variant="body2" color="text">
          {messages.whatsappCompletionMessagesText1Part2}
        </MDTypography>
      </MDBox>
    </MDBox>
  );
}
